
export function clearStore() {
    return async function (dispatch, getStore) {
        dispatch({type: "CLEAR_STORE"});
    }
}

export function setStore(storeId) {
    return async function (dispatch, getStore) {
        dispatch({type: "SET_STORE", storeId: storeId});
    }
}